export default {
    es: {
        title: "Nuestros Autobuses",
        text1_iframe: "RECORRIDO",
        text2_iframe: "VIRTUAL",
        title_amenities: 'AMENIDADES',
        amenities: {
            airconditioning: "AIRE ACONDICIONADO",
            reposet: "ASIENTOS REPOSET",
            wifi: "WIFI",
            screens: "PANTALLAS INDIVIDUALES",
            bathrooms: "2 BAÑOS",
            connector: "CONTACTOS 100V",
        }
    },
    en: {
        title: "Our Buses",
        text1_iframe: "VIRTUAL",
        text2_iframe: "TOUR",
        title_amenities: 'AMENITIES',
        amenities: {
            airconditioning: "AC",
            reposet: "REPOSET",
            wifi: "WIFI",
            screens: "SCREENS",
            bathrooms: "2 RESTROOMS",
            connector: "100V CONNECTION",
        }
    }
}